import { initCopy } from "./copy";
import { initGallery, initLightbox } from "./gallery";
import { initNav } from "./nav";
import { initRelease } from "./release";
import { initReveal, initSpotlight } from "./reveal";
import { initVideos } from "./video";

function boot(): void {
  initNav();
  initSpotlight();
  document.querySelectorAll<HTMLElement>("[data-gallery]").forEach(initGallery);
  initLightbox();
  initVideos();
  initCopy();
  void initRelease();
}

// Runs once styles are applied and the browser has jumped to any #section.
function afterLoad(): void {
  requestAnimationFrame(() => {
    initReveal();
    document.documentElement.classList.add("is-loaded");
  });
}

if (document.readyState === "complete") {
  afterLoad();
} else {
  window.addEventListener("load", afterLoad, { once: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
